import { Injectable } from '@angular/core';
import {imageExtensions} from "../models/image-extensions";

@Injectable({
  providedIn: 'root'
})
export class ValidationFilesService {
  public isImage(fileName: string): boolean {
    return imageExtensions.some(ext => fileName.toLowerCase().endsWith(ext));
  }
}
